import color from "../../../constants/color";

const style ={
  mainHeading: {
    fontSize: "20px",
    fontWeight: "600",
    color:color.text
  },
  addButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: color.primary, 
    fontSize: "12px",
    fontWeight: "500",
    px: 4,
    boxShadow: "none",
    marginRight:"5px",
    whiteSpace:"nowrap"
  },
  mainBox: {
    width: "100%",
    m: "16px",
    display: "flex",
    flexDirection:{xs:"column", md:"column", lg:"row"},
    justifyContent: "space-between",
    alignItems: "baseline",
    backgroundColor:"white"
  },
  gridbioBoxs: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px:2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",
    
  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"5.5px 14px",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    },
    width:"100%"
  },
  inputContainer:{
    // width:{xs:"18em",md:"30em",},
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between",
    width:"100%"
  },
  inputLabel:{
    fontSize:"12px",
    fontWeight:"500",
    color:color.text
  },
  dropDownMenu:{
    fontSize:"14px",
    fontWeight:"400",
    my:1
  },
  name:{
    fontSize:"14px",
    fontWeight:"400",
    color:color.text,
    whiteSpace:"nowrap"
  },
  TableHead: {
    color: "#878787",
    fontWeight: "400",
    whiteSpace:"nowrap"
  },
  viewIcon: {
    color: color.lightText,
    fontSize: "1.3rem",
    mx: 2
  },
};
export default style;